/* @flow */
import { API_URL } from '../../Constants';
import { compact } from '../../utils';

export function createFareEstimateBatch(originId: string, destinationId: string, useCase?: string) {
  let body = {};
  if (originId) body.origin_id = originId;
  if (destinationId) body.destination_id = destinationId;
  if (useCase) body.use_case = useCase;

  return {
    url: `${API_URL}/fare-estimates/batch`,
    options: {
      method: 'POST',
    },
    body,
    transform: (response: Object) => ({
      fareEstimatesByLocationIds: response,
      fareEstimatesById: response,
    }),
    update: {
      fareEstimatesByLocationIds: (prevFareEstimates: Object, fareEstimates: Array<Object>) => ({
        ...prevFareEstimates,
        [compact([originId, destinationId, useCase]).join(':')]: fareEstimates,
      }),
      fareEstimatesById: (prevFareEstimates: Object, fareEstimates: Array<Object>) => ({
        ...prevFareEstimates,
        ...fareEstimates.reduce((memo, value) => {
          memo[value.id] = value;
          return memo;
        }, {}),
      }),
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/fare-estimates/queries.js